import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";



const Elimination = (props) => {
    
        const [contestData, setContestData] = useState(props.contestData);
        const [defaultAccordion, setDefaultAccordion] = useState(props.defaultAccordion);

    return (
         <Accordion defaultActiveKey={defaultAccordion} className="rules-accordion">
                                {contestData && contestData.contestDetails[0].contest_type_id == 2 && <Accordion.Item eventKey="0">
                                    <Accordion.Header>Knockout Plus Variant</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Just like in our standard contests, there is only one winner in the elimination contest. That winner is the Champion of the Knockout Plus. However, additional prizes are awarded to:</p>
                                        <p>Weekly High Scores (criteria varies by contest)</p>
                                        <p>Season Long Points Totals (number of winners varies by contest)</p>
                                        <div className="play-basics">
                                            <h5>Fantasy Sports Knockout uses the following standard scoring:</h5>
                                            <div className="scoring-data">
                                                <div className="player-position">
                                                    <h5>OFFENSE</h5>
                                                    <h6>Each Yard:</h6>
                                                    <p>Passing: 0.04 points</p>
                                                    <p>Receiving/Rushing: 0.1 point</p>
                                                    <h6>Touchdowns:</h6>
                                                    <p>Passing: 4 points</p>
                                                    <p>ALL other TDs scored by a player (including receiving, rushing, special teams and turnover recoveries): 6 points</p>
                                                    <p>All Turnovers (fumbles lost, interceptions thrown): -2 points</p>
                                                    <p>Receptions: 1 point each</p>
                                                    <p>2-point conversion (all types): 2 points</p>
                                                </div>
                                                <div className="player-position special">
                                                    <h5>DST</h5>
                                                    <p>All Touchdowns: 6 points</p>
                                                    <p>All Turnovers (fumbles recovered, interceptions): 2 points</p>
                                                    <p>Sacks: 1 point</p>
                                                    <p>Safety: 2 points</p>
                                                    <p>1-point Safety: 1 point</p>
                                                </div>
                                                <div className="player-position">
                                                    <h5>KICKER</h5>
                                                    <p>Extra Points: 1 point</p>
                                                    <p>Field Goal 0-39: 3 points</p>
                                                    <p>Field Goal 40-49: 4 points</p>
                                                    <p>Field Goal 50+: 5 points</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                }
                               

                                 <Accordion.Item eventKey="1">
                                    <Accordion.Header>Weekly Elimination Formula</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Example Only</p>
                                        <div className="tags-sec">
                                            <span className="tag">100 player contest with 13 weeks</span><span className="tag">1st Half: 6 weeks - 2nd Half: 7 weeks</span>
                                            <span className="tag">Alive for 2nd half: 8</span><span className="tag">Eliminated 1st half: 92</span><span className="tag">92 / 6 =15.3, rounded down to 15</span>
                                            <span className="tag">15 (per week) x 6 (weeks) = 90</span><span className="tag">92 - 90 = 2</span>
                                            <span className="tag">Two (2) additional eliminated in week 1 (17)</span>
                                        </div>
                                        <p>For the final half of the contest, we will eliminate one (1) user per week. For the first half of the contest, we will eliminate all other users. We determine the number of weeks in each half by dividing the number of weeks in the contest by 2.
                                            If the contest contains an odd number of weeks, the second half will contain the higher number of weeks. Subtract the number of weeks in the second half and add one to determine how many users will be alive for the second half.
                                            Subtract the number from the previous example from the total number of users in the contest to determine how many will be eliminated in the first half. Divide the sum of users that will be eliminated in the first half equally
                                            amongst the weeks in the first half. In most cases, this will not be a round number. Therefore, round the calculated result down, and eliminate the remainder in Week 1.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                               
                                
                              
                            </Accordion>

    )
}

export default Elimination

